export const companies = state => _.orderBy(state.companies.items, [item => item.name.toLowerCase()], ['asc'])
export const companyById = state => id => _.find(companies(state), {id})
export const companiesByIds = state => ids => {
    return _.reduce(ids, (res, id) => {
        let company = companyById(state)(id)
        if (company) res.push(company)
        return res
    }, [])
}
export const companyNameById = state => id => {
    let company = companyById(state)(parseInt(id))
    return company ? company.name : ''
}
